import { Component, Inject, OnInit, EventEmitter } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { environment } from "../../../../../../environments/environment";
import { Constants } from "../../../../../core/services/constants.service";
import { STEPPER_GLOBAL_OPTIONS } from "@angular/cdk/stepper";
import { HttpService } from "src/app/core";
import { ToastrService } from "ngx-toastr";
import { HttpEvent, HttpEventType } from "@angular/common/http";

@Component({
  selector: "app-edit-floorplan-dialog",
  templateUrl: "./edit-floorplan-dialog.component.html",
  styleUrls: ["./edit-floorplan-dialog.component.scss"],
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false },
    },
  ],
})
export class EditFloorplanDialogComponent implements OnInit {
  floorPlan: any;
  project: any;
  currentStep = 0;
  isEdit = false;
  showAndroidFilePreview = false;

  firstFormGroup: FormGroup;
  onUpdate = new EventEmitter();
  onCreate = new EventEmitter();

  iosFileProgress = {
    progress: 0,
    filename: "",
    isUploading: false,
  };
  iosUploadSubscribe: any;

  androidFileProgress = {
    progress: 0,
    filename: "",
    isUploading: false,
  };
  androidUploadSubscribe: any;

  constructor(
    private formBuilder: FormBuilder,
    private httpService: HttpService,
    private toastrService: ToastrService,
    private dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.firstFormGroup = this.formBuilder.group({
      notes: ["", Validators.required],
      bedRoom: [""],
      bathRoom: [""],
    });
  }

  ngOnInit(): void {
    this.floorPlan = this.data.floorPlan;
    this.project = this.data.project;
    this.isEdit = this.data.isEdit;
    this.currentStep = this.data.step || 0;

    if (this.isEdit) {
      this.firstFormGroup.patchValue({
        notes: this.floorPlan.notes,
      });

      if (this.floorPlan.hasOwnProperty("bedRoom")) {
        this.firstFormGroup.patchValue({
          bedRoom: this.floorPlan.bedRoom,
        });
      }
      if (this.floorPlan.hasOwnProperty("bathRoom")) {
        this.firstFormGroup.patchValue({
          bathRoom: this.floorPlan.bathRoom,
        });
      }
    }
  }

  isImageValid(file) {
    return (
      file.size <= Constants.UPLOAD_FLOOR_PLAN_IMAGE_SIZE &&
      file.name.length < 255
    );
  }
  isFileValid(file) {
    return (
      file.size <= Constants.UPLOAD_FLOOR_PLAN_AR_SIZE && file.name.length < 255
    );
  }

  getImageUrl(fileName: string) {
    return (
      environment.SERVER_URL +
      "images/" +
      this.project.projectCode +
      "/floor_plans/" +
      fileName
    );
  }

  getFileUrl(fileName: string) {
    return (
      environment.VERIFICATION_CODE_URL +
      "files/" +
      this.project.projectCode +
      "/floor_plans/" +
      fileName
    );
  }

  cancel() {
    this.dialogRef.close({
      floorPlan:this.floorPlan
    });
  }

  updateFloorplan(lastStep?: string) {
    if (!this.firstFormGroup.dirty || !this.firstFormGroup.valid) {
      return;
    }

    const fd = new FormData();
    fd.append("notes", this.firstFormGroup.get("notes").value);
    fd.append("projectId", this.project.id);

    if (
      this.firstFormGroup.get("bedRoom").value ||
      this.firstFormGroup.get("bedRoom").value === 0
    ) {
      fd.append("bedroom", this.firstFormGroup.get("bedRoom").value);
    }
    if (
      this.firstFormGroup.get("bathRoom").value ||
      this.firstFormGroup.get("bathRoom").value === 0
    ) {
      fd.append("bathroom", this.firstFormGroup.get("bathRoom").value);
    }

    if (this.floorPlan) {
      // 更新floorpaln
      this.httpService
        .editFloorPlanNotes(fd, this.floorPlan.id)
        .subscribe((res: any) => {
          console.log(res);
          if (res.code === 1) {
            this.floorPlan = res.data;
            console.log("this.onUpdate", this.onUpdate);
            if (lastStep) this.dialogRef.close({ floorPlan: this.floorPlan });
            // this.onUpdate.emit({ floorPlan: this.floorPlan });
            this.isEdit = true;
            this.toastrService.success("Floor plan update successful");
          } else {
            this.toastrService.error("Failed to update floor plan notes.");
          }
        });
    } else {
      // 创建florPlan

      this.httpService.uploadFloorPlans(fd).subscribe((res: any) => {
        console.log(res);
        if (res.code === 1) {
          this.floorPlan = res.data;
          console.log("this.onCreate", this.onCreate);
          // this.onCreate.emit({ floorPlan: this.floorPlan });
          if (lastStep) this.dialogRef.close({ floorPlan: this.floorPlan });
          this.toastrService.success("Floor plan create successful");
        } else {
          this.toastrService.error("Floor plan create failed");
        }
      });
    }
  }

  // 数据是实时保存，确认直接关闭
  submit() {
    this.dialogRef.close({
      floorPlan:this.floorPlan
    });
  }

  showPreviewContent() {
    this.showAndroidFilePreview = true;
  }

  onImageSelect(event) {
    // 前端暂时去掉 图像大小的限制
    // event.addedFiles.forEach((item) => {
    //   if (item.size > 1048576) {
    //     this.toastrService.error("Failed to update image (max 1MB)");
    //     return;
    //   }
    // });
    event.addedFiles.forEach((file) => {
      const fd = new FormData();
      fd.append("image", file);

      // 上传图片
      this.httpService
        .addImageToFloorPlan(fd, this.floorPlan.id)
        .subscribe((res: any) => {
          this.onUpdate.emit({ floorPlan: res.data });

          res.data.images.forEach((image) => {
            if (!this.floorPlan.images) {
              this.floorPlan.images = [];
            }
            if (!this.floorPlan.images.find((img) => img.id === image.id)) {
              this.floorPlan.images.push(image);
            }
          });
        });
    });
  }

  onImageRemove(image) {
    this.httpService
      .deleteImageFromFloorPlan(this.floorPlan.id, image.id)
      .subscribe((res: any) => {
        console.log(res);

        this.floorPlan.images = this.floorPlan.images.filter((image) => {
          return res.data.images.find((img) => img.id === image.id);
        });
        this.onUpdate.emit({ floorPlan: res.data });
      });
  }

  // 上传ar文件
  onFileSelect(event, prefix) {
    const file = event.addedFiles[0];
    if (!file) {
      return;
    }
    if (!this.isFileValid(file)) {
      this.toastrService.error(
        "File size should be less than " +
        Constants.UPLOAD_FLOOR_PLAN_AR_SIZE / 1024 / 1024 +
        "MB"
      );
      return;
    }

    if (prefix === "ios") {
      this.iosFileProgress.isUploading = true;
      this.iosFileProgress.filename = file.name;

      const fd = new FormData();
      fd.append("file", file);
      // 上传进度条
      this.iosUploadSubscribe = this.httpService
        .uploadArModel(this.floorPlan.id, fd, prefix)
        .subscribe((event: HttpEvent<any>) => {
          switch (event.type) {
            case HttpEventType.Sent:
              console.log("Request has been made!");
              break;
            case HttpEventType.ResponseHeader:
              console.log("Response header has been received!");
              break;
            case HttpEventType.UploadProgress:
              this.iosFileProgress.progress = Math.round(
                (event.loaded / event.total) * 100
              );
              break;
            case HttpEventType.Response:
              const response = event.body;
              if (response.code === 1) {
                if (!this.floorPlan.urls) {
                  this.floorPlan.urls = {};
                }
                this.floorPlan.urls.ios = response.data.ios;
                this.onUpdate.emit({ floorPlan: this.floorPlan });
              } else {
                this.toastrService.error("Android model uploading failed");
              }
              this.iosFileProgress.progress = 0;
              this.iosFileProgress.isUploading = false;
          }
        });
    }
    if (prefix === "android") {
      this.androidFileProgress.isUploading = true;
      this.androidFileProgress.filename = file.name;

      const fd = new FormData();
      fd.append("file", file);
      // 上传进度条
      this.androidUploadSubscribe = this.httpService
        .uploadArModel(this.floorPlan.id, fd, prefix)
        .subscribe((event: HttpEvent<any>) => {
          switch (event.type) {
            case HttpEventType.Sent:
              console.log("Request has been made!");
              break;
            case HttpEventType.ResponseHeader:
              console.log("Response header has been received!");
              break;
            case HttpEventType.UploadProgress:
              this.androidFileProgress.progress = Math.round(
                (event.loaded / event.total) * 100
              );
              break;
            case HttpEventType.Response:
              const response = event.body;
              if (response.code === 1) {
                if (!this.floorPlan.urls) {
                  this.floorPlan.urls = {};
                }
                this.floorPlan.urls.android = response.data.android;
                this.onUpdate.emit({ floorPlan: this.floorPlan });
              } else {
                this.toastrService.error("Android model uploading failed");
              }

              this.androidFileProgress.progress = 0;
              this.androidFileProgress.isUploading = false;
          }
        });
    }
  }

  // 取消ios上传
  cancelIosUpload() {
    this.iosUploadSubscribe.unsubscribe();
    this.iosFileProgress.isUploading = false;
    this.iosFileProgress.progress = 0;
  }

  // 取消android上传
  cancelAndroidUpload() {
    this.androidUploadSubscribe.unsubscribe();
    this.androidFileProgress.isUploading = false;
    this.androidFileProgress.progress = 0;
  }

  // 删除 ar文件
  onFileRemove(prefix) {
    if (prefix === "ios") {
      this.httpService.deleteIosAr(this.floorPlan.id).subscribe((res: any) => {
        console.log(res);
        if (res.code === 1) {
          delete this.floorPlan.urls.ios;
          this.onUpdate.emit({ floorPlan: this.floorPlan });
          // this.toastrService.success('IOS model delete successful');
        } else {
          this.toastrService.error("IOS model delete failed");
        }
      });
    }
    if (prefix === "android") {
      this.httpService
        .deleteAndroidAr(this.floorPlan.id)
        .subscribe((res: any) => {
          console.log(res);
          if (res.code === 1) {
            delete this.floorPlan.urls.android;
            this.onUpdate.emit({ floorPlan: this.floorPlan });
            // this.toastrService.success('Android model delete successful');
          } else {
            this.toastrService.error("Android model delete failed");
          }
        });
    }
  }

  openFile(fileName) {
    window.open(encodeURI(this.getFileUrl(fileName)));
  }

  validateInput(event: Event) {
    const input = event.target as HTMLInputElement;
    const regex = /^\d*\.?\d*$/;
    if (!regex.test(input.value)) {
      input.value = '0';
    }
  }
}
